import React from 'react';
import FilterType from './FilterType';

export default class ColumnInformation {
	constructor({
		// == REQUIRED == //
		// - title: string - the title to show on the column heading
		title,
		// - field: string - the name of the field in the record object being shown. ie object[field] is shown in the row
		field,

		// == Optional == //
		// - tableSorterInformation: information about sorting this column
		tableSorterInformation,
		// - tdCallback: draw your own custom td; (columnInfo, objectData) => <td/>
		// - you must return a <td>
		tdCallback,
		// - tdClassName: add this string or function to the td's class name; allows targeting tds for styling and etc
		tdClassName,
		// - thClassName: additional classes to put on the column header
		thClassName,
		// - key: if there is no field then the td needs a key, so define it here
		key,
		// - filter: set to false if you do not want to filter a specific column; will show an empty <td/> instead
		filter,
		// - filterCallback: get the filtered list and value of the filter back; This tells the parent when the filter changes
		filterCallback,
		/// - filterType: if filtering, then can choose what type of filtering input to use
		filterType,
		// - filterTypeOptions: if filtering and filtering type is SELECT then can provide a list of options
		// if no options provided then will scan data for possible values
		filterTypeOptions,
		// - filterDefault: add a value for the filter when the table is first rendered
		filterDefaultValue,
		// - filterDataCallback : tells if a piece of data should be filtered
		// filterType tells how the user interacts with the filter; this callback tells how the data is filtered
		// parameters are: data (a data object in the dataList), filterValue (current value of the filter), filterList (all the filters and their values), dataList (the complete data list), index (index of the data object in the dataList)
		// return: true if should be included in the list, false if the data object is filtered out of the list
		// !! alert !! filter values are raw and js string compares are case sensitive, so be careful
		filterDataCallback,
	}) {
		const defaultValue = (value, defaultValue) => value === undefined ? defaultValue : value;

		this.title = defaultValue(title, false);
		this.field = defaultValue(field, false);
		this.tableSorterInformation = defaultValue(tableSorterInformation, undefined);
		this.tdCallback = defaultValue(tdCallback, false);
		this.tdClassName = defaultValue(tdClassName, '');
		this.thClassName = defaultValue(thClassName, '');
		this.key = defaultValue(key, '');
		this.filter = defaultValue(filter, true);
		this.filterCallback = defaultValue(filterCallback, false);
		this.filterType = defaultValue(filterType, undefined);
		this.filterTypeOptions = defaultValue(filterTypeOptions, undefined);
		this.filterDefaultValue = defaultValue(filterDefaultValue, undefined);
		this.filterDataCallback = defaultValue(filterDataCallback, undefined);


		if (!this.field && !this.key) {
			console.error('ColumnInformation Must have either a field or a key so that trs are defined. TDs like a delete button may have no field but need a key');
		}
	}
}

ColumnInformation.FilterType = FilterType;